<template>
  <div>
    <div v-if="dm" class="form-group row mb-3">
      <label class="col-sm-4" for="foepulet_falazat"
        ><h1>Partnerkód</h1>
        <!-- <span
          class="info"
          id="foepulet_falazat-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          >?</span
        > -->
      </label>
      <div class="col-sm-3">
        <select
          class="form-select dark-border"
          id="foepulet_falazat"
          name="foepulet_falazat"
          v-model="partnertipus"
          required
        >
          <option :value="''"></option>
          <option :value="'FORENSIS'">FORENSIS</option>
        </select>
      </div>
    </div>
    <h1>Alap Adatok</h1>
    <div>
      <div class="form-group row mb-3">
        <label class="col-sm-4" for="biztositas_targya"
          >Mire kíván biztosítást kötni?
          <span class="text-danger">*</span></label
        >
        <div class="col-sm-8">
          <div class="row">
            <input
              id="biztositas_targya"
              type="text"
              hidden
              name="biztositas_targya"
              :value="'ingatlan_ingosag'"
              v-if="contractFor == 1"
            />
            <input
              id="biztositas_targya"
              type="text"
              hidden
              name="biztositas_targya"
              :value="'ingatlan'"
              v-else-if="contractFor == 2"
            />
            <input
              id="biztositas_targya"
              type="text"
              hidden
              name="biztositas_targya"
              :value="'ingosag'"
              v-else-if="contractFor == 3"
            />
            <div class="col-md-4 form-group mb-2">
              <button
                type="button"
                class="btn w-100"
                @click="contractFor = 1"
                :class="{
                  'btn-red': contractFor == 1,
                  'btn-outline-danger': contractFor !== 1,
                }"
              >
                Ingatlan és ingóság
              </button>
            </div>
            <div class="col-md-4 form-group mb-2">
              <button
                type="button"
                class="btn w-100"
                @click="contractFor = 2"
                :class="{
                  'btn-red': contractFor == 2,
                  'btn-outline-danger': contractFor !== 2,
                }"
              >
                Csak ingatlan
              </button>
            </div>
            <div class="col-md-4 form-group mb-2">
              <button
                type="button"
                class="btn w-100"
                @click="contractFor = 3"
                :class="{
                  'btn-red': contractFor == 3,
                  'btn-outline-danger': contractFor !== 3,
                }"
              >
                Csak ingóság
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >Milyen típusú a biztosítani kívánt ingatlan?
          <span class="text-danger">*</span>
          <button
            type="button"
            class="info"
            id="tipusa-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ingatlan_tipus"
              id="tipusa_lakas"
              :value="'tarsashaz'"
              v-model="propertyType"
            />
            <label class="form-check-label" for="tipusa_lakas">
              Társasházi lakás
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ingatlan_tipus"
              id="tipusa_csaladihaz"
              :value="'csaladihaz'"
              v-model="propertyType"
            />
            <label class="form-check-label" for="tipusa_csaladihaz">
              Családi ház
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ingatlan_tipus"
              id="tipusa_sorhaz"
              :value="'sorhaz'"
              v-model="propertyType"
            />
            <label class="form-check-label" for="tipusa_sorhaz">
              Sorház
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ingatlan_tipus"
              id="tipusa_ikerhaz"
              :value="'ikerhaz'"
              v-model="propertyType"
            />
            <label class="form-check-label" for="tipusa_ikerhaz">
              Ikerház
            </label>
          </div>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >A biztosítani kívánt ingatlan állandóan lakott?
          <span class="text-danger">*</span>
          <button
            type="button"
            class="info"
            id="allandoan_lakott-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <ValidationProvider :immediate="true" class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="allando_lakott"
              id="allandoan_lakott_igen"
              :value="1"
              v-model="propertyInhabitated"
            />
            <label class="form-check-label" for="allandoan_lakott_igen">
              Igen
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="allando_lakott"
              id="allandoan_lakott_nem"
              :value="0"
              v-model="propertyInhabitated"
            />
            <label class="form-check-label" for="allandoan_lakott_nem">
              Nem
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="allando_lakott"
              id="allandoan_lakott_reszben"
              :value="2"
              v-model="propertyInhabitated"
            />
            <label class="form-check-label" for="allandoan_lakott_reszben">
              Részben <i>(Második otthonként használt ingatlan)</i>
            </label>
          </div>
        </ValidationProvider>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >Az ingatlan külterületen helyezkedik el?
          <span class="text-danger">*</span>
          <button
            type="button"
            class="info"
            id="kulterulet-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="kulterulet"
              id="kulterulet_nem"
              :value="0"
              v-model="propertyOutskirts"
            />
            <label class="form-check-label" for="kulterulet_nem">
              Nem
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="kulterulet"
              id="kulterulet_igen"
              :value="1"
              v-model="propertyOutskirts"
            />
            <label class="form-check-label" for="kulterulet_igen">
              Igen
            </label>
          </div>
          <small id="kulterulet-error" class="text-danger input-alert"></small>
        </div>
      </div>
      <!-- <div class="form-group row mb-3">
        <label class="col-sm-4"
          >Újjáépítés? <span class="text-danger">*</span>
          <span
            class="info"
            id="ujraepites-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            >?</span
          ></label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ujraepites"
              id="ujraepites_nem"
              :value="0"
              v-model="rebuild"
            />
            <label class="form-check-label" for="ujraepites_nem">
              Nem
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ujraepites"
              id="ujraepites_igen"
              :value="1"
              v-model="rebuild"
            />
            <label class="form-check-label" for="ujraepites_igen">
              Igen
            </label>
          </div>
          <small id="kulterulet-error" class="text-danger input-alert"></small>
        </div>
      </div> -->
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >Folytatnak-e olyan vállalkozási tevékenységet az ingatlanban, ami nem
          szellemi munkavégzés? <span class="text-danger">*</span>
          <button
            type="button"
            class="info"
            id="fizikai-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <ValidationProvider
          :immediate="true"
          class="col-sm-8"
          v-slot="{ errors }"
        >
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="fizikai"
              id="vallalkozas_nem"
              :value="0"
              v-model="propertyPhysicalJob"
            />
            <label class="form-check-label" for="vallalkozas_nem">
              Nem
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="fizikai"
              id="vallalkozas_igen"
              :value="1"
              v-model="propertyPhysicalJob"
            />
            <label class="form-check-label" for="vallalkozas_igen">
              Igen
            </label>
            <small
              id="foepulet_falazat-error"
              class="text-danger input-alert"
            ></small>
          </div>
          <span v-if="showPropertyPhysicalWarning()"
            ><small class="text-warning fw-bold"
              >Fizikai munkavégzéssel járó vállalkozási tevékenység esetén nem
              tudunk automatikusan biztosítási díjat számolni. Ebben az esetben
              biztosítási ajánlatát egyedi elbírálás alapján állítjuk ki. Kérjük
              adja meg a vállakozás típusát és folytassa a kalkulációt.</small
            ></span
          >
          <small id="fizikai-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
      <ValidationProvider
        rules="required"
        class="form-group row mb-3"
        v-if="propertyPhysicalJob"
        v-slot="{ errors, classes }"
      >
        <label class="col-sm-4" for="fizikai_megnev"
          >Munkavégzés tevékenysége: <span class="text-danger">*</span></label
        >
        <div class="col-sm-8">
          <input
            class="form-control mb-2"
            :class="{ classes, 'dark-border': true }"
            type="text"
            id="fizikai_megnev"
            name="fizikai_megnev"
            v-model="propertyPhysicalJobName"
          />
          <small
            id="fizikai_megnev-error"
            class="text-danger input-alert"
            v-if="errors.length > 0"
            >{{ errors[0] }}</small
          >
        </div>
      </ValidationProvider>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >Az ingatlan tulajdonjoga: <span class="text-danger">*</span>
          <button
            type="button"
            class="info"
            id="tulajdonjog-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="tulajdonjog"
              id="ingatlan_tulajdon_sajat"
              :value="'sajat'"
              v-model="propertyOwnRight"
            />
            <label class="form-check-label" for="ingatlan_tulajdon_sajat">
              Saját tulajdon saját használatban
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="tulajdonjog"
              id="ingatlan_tulajdon_berbe"
              :value="'sajat_berbe'"
              v-model="propertyOwnRight"
            />
            <label class="form-check-label" for="ingatlan_tulajdon_berbe">
              Saját tulajdon bérbe adva
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="tulajdonjog"
              id="ingatlan_tulajdon_berlemeny"
              :value="'berlemeny'"
              v-model="propertyOwnRight"
            />
            <label class="form-check-label" for="ingatlan_tulajdon_berlemeny">
              Bérlemény
            </label>
          </div>
          <small id="tulajdonjog-error" class="text-danger input-alert"></small>
        </div>
      </div>
      <!--RBNB RÉSZ  -->
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >Szeretné a lakásbiztosítását kiegészíteni egy speciálisan rövid távú
          bérbeadásban érintett ingatlanokra kifejlesztett szolgáltatási
          csomaggal? <span class="text-danger">*</span>
          <button
            type="button"
            class="info"
            id="rbnb-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="rbnb[]"
              id="rbnb[]"
              :value="0"
              v-model="rbnb"
            />
            <label class="form-check-label" for="ingatlan_tulajdon_sajat">
              Nem
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="rbnb[]"
              id="rbnb[]"
              :value="1"
              v-model="rbnb"
              :disabled="this.propertyOwnRight !== 'sajat_berbe'"
            />
            <label class="form-check-label" for="ingatlan_tulajdon_berbe">
              Igen
            </label>
          </div>
          <small id="tulajdonjog-error" class="text-danger input-alert"></small>
        </div>
      </div>
      <div v-if="rbnb === 1" class="form-group row mb-3">
        <label class="col-sm-4" for="rbnb_berletidij"
          >Az ingatlan egy napra kalkulált bruttó bérleti díja:<span
            class="text-danger"
            >*</span
          >
        </label>
        <ValidationProvider
          :rules="{ required: true, currency_min: 1 }"
          v-slot="{ errors, classes }"
          class="col-sm-8"
        >
          <div class="input-group">
            <input
              v-currency="{ valueRange: { min: 1 } }"
              class="form-control dark-border"
              :class="{ classes, 'dark-border': true }"
              aria-describedby="rbnb_berletidij-prepend"
              v-model="rbnbPrice"
            />
            <input
              v-show="false"
              class="form-control dark-border"
              id="rbnb_berletidij"
              name="rbnb_berletidij"
              :class="{ classes, 'dark-border': true }"
              aria-describedby="rbnb_berletidij-prepend"
              v-model="rbnbPrice"
            />
            <div class="input-group-append d-block dark-border">
              <span class="input-group-text" id="rbnb_berletidij-prepend"
                >Ft</span
              >
            </div>
          </div>
          <small id="rbnb_berletidij-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4" for="ingatlan_iranyito"
          >Az ingatlan irányítószáma: <span class="text-danger">*</span></label
        >
        <div class="col-sm-8">
          <div class="col-md-8 mb-2 dark-border">
            <!-- <v-select 
              id="ingatlan_iranyito"
              name="iranyitoszam"
              :options="zipCodes" 
              v-model="propertyZip"
              :clearable="false"
              :multiple="false"
              class="select-zip"
              :noDrop="true"
            /> -->
            <ValidationProvider rules="required|zipcode" v-slot="{ errors }">
              <input
                type="text"
                id="ingatlan_iranyito"
                name="iranyitoszam"
                v-model="propertyZip"
                v-show="true"
                class="form-control dark-border"
              />
              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
            <!-- <Select2
              id="ingatlan_iranyito"
              name="iranyitoszam"
              v-model="propertyZip"
              :options="zipCodes"
              :settings="{selectionCssClass: 'w-full'}"
            /> -->
          </div>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4" for="telepules"
          >Település: <span class="text-danger">*</span></label
        >
        <div class="col-md-8 mb-2">
          <div class="col-md-4 mb-2 dark-border">
            <div v-if="cityNames.length > 1">
              <!-- <v-select 
                id="telepules"
                name="telepules"
                v-model="selectedPropertyName"
                :options="cityNames"
                :clearable="false"
                class="dark-border"
              /> -->
              <select
                id="telepules"
                name="telepules"
                v-model="selectedPropertyName"
                class="form-select dark-border"
              >
                <option
                  v-for="(city, key) in cityNames"
                  :key="key"
                  :value="city"
                  >{{ city }}</option
                >
              </select>
            </div>
            <!-- <Select2
              id="telepules"
              name="telepules"
              v-model="selectedPropertyName"
              :options="cityNames"
              :settings="{selectionCssClass: 'w-full'}"
              v-if="cityNames.length > 1"
            /> -->
            <input
              v-else
              id="telepules"
              type="text"
              class="form-control mb-2 dark-border"
              readonly
              name="telepules"
              :value="selectedPropertyName"
            />
            <ValidationProvider rules="required" v-slot="{ errors }">
              <input type="text" :value="selectedPropertyName" v-show="false" />
              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
      </div>
    </div>
    <h1 class="h2 mt-4">Kockázatviselés kezdete</h1>
    <div class="form-group row mb-3">
      <label class="col-sm-4" for="kockazat_kezdete" id="kockazat_kezdete_label"
        >Kockázatviselés kezdete: <span class="text-danger">*</span></label
      >
      <div class="col-sm-8">
        <input
          id="kockazat_kezdete"
          autocomplete="off"
          class="form-control dark-border"
          type="date"
          name="kockazat_kezdete"
          :min="riskStartMinDate"
          :max="riskStartMaxDate"
          v-model="startDate"
          required
        />
        <!-- <Datepicker
          id="kockazat_kezdete_dp1"
          :format="'yyyy-MM-dd'"
          :placeholder="'ÉÉÉÉ-HH-NN'"
          :language="hu"
          :disabled-dates="riskStartDisabledDates"
          :typeable="true"
          input-class="form-control"
          :monday-first="true"
          required
          aria-describedby="kockazat_kezdet_dp1_label"
          v-model="startDate"
        ></Datepicker> -->
        <ValidationProvider
          :immediate="true"
          rules="required|kockazat_kezdet"
          v-slot="{ errors }"
        >
          <input v-show="false" type="text" :value="startDate" readonly />
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4" for="szerzodo_szuletesi_datum"
        >Szerződő születési dátuma: <span class="text-danger">*</span></label
      >
      <!--  :disabled-dates="contractedIsInsured ? biztDisabledDates : bornDisabledDates" 
            :open-date="bornInitialDate"
      -->
      <div class="col-sm-8">
        <input
          autocomplete="off"
          id="szerzodo_szuletesi_datum"
          class="form-control dark-border"
          name="szerzodo_szuletesi_datum"
          type="date"
          :min="birthMinDate"
          :max="birthMaxDate"
          v-model="contractorBornDate"
          required
        />
        <!-- <Datepicker
          class="dark-border"
          id="szerzodo_szuletesi_datum_dp1"
          :format="'yyyy-MM-dd'"
          :placeholder="'Kattintson ide a dátum kiválasztásához vagy kezdje el begépelni'"
          :language="hu"
          :disabled-dates="bornDisabledDates"
          :typeable="true"
          input-class="form-control"
          :monday-first="true"
          required
          v-model="contractorBornDate"
          aria-label="Születési dátum"
          :open-date="maxBornDate"
        ></Datepicker> -->
        <ValidationProvider
          :immediate="true"
          rules="required|szerzodes_szuletes_datum"
          v-slot="{ errors }"
        >
          <input
            v-show="false"
            type="text"
            :value="contractorBornDate"
            readonly
          />
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
    </div>
    <!-- <div class="col-md-6 mb-3">
      <label class="col-sm-4" for="szerzodo_szuletesi_datum"
        >Kockázatviselés kezdete: <span class="text-danger">*</span></label
      >
      <div class="input-group flex-nowrap">
        <div class="input-group-prepend">
          <span class="input-group-text" id="szerzodo_szuletesi_datum-prepend"
            >Születési dátum: <span class="text-danger">*</span></span
          >
        </div>
        <Datepicker
          id="szerzodo_szuletesi_datum"
          name="szerzodo_szuletesi_datum"
          :format="'yyyy-MM-dd'"
          :placeholder="'Kattintson ide a dátum kiválasztásához'"
          :language="hu"
          :disabled-dates="contractedIsInsured ? biztDisabledDates : bornDisabledDates"
          :typeable="false"
          input-class="form-control"
          :open-date="bornInitialDate"
          required
          v-model="contractorBornDate"
          aria-label="Születési dátum"
          aria-describedby="szerzodo_szuletesi_datum-prepend"
          class="datepicker-prepend-input"
        ></Datepicker>
      </div>
      <ValidationProvider
        :immediate="true"
        rules="required|szerzodes_szuletes_datum"
        v-slot="{errors}"
      >
        <input
          type="text"
          name="szerzodo_szuletesi_datum"
          :value="contractorBornDate"
          disabled
          hidden
        />
        <small class="text-danger input-alert">{{ errors[0] }}</small>
      </ValidationProvider>
    </div> -->
    <h1 class="mt-5">Biztosítani Kívánt Főépület Adatai</h1>
    <div class="form-group row mb-3">
      <label class="col-sm-4" for="hasznos_terulet"
        >Mekkora az épület/ingatlan hasznos alapterülete? (m2)
        <span class="text-danger">*</span>
        <button
          type="button"
          class="info"
          id="foepulet_alapterulet-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?
        </button></label
      >
      <ValidationProvider
        rules="required|min_value:10|max_value:9999"
        v-slot="{ errors, classes }"
        class="col-sm-8"
      >
        <div class="input-group">
          <input
            class="form-control dark-border"
            type="number"
            min="1"
            max="9999"
            name="alapterulet"
            id="hasznos_terulet"
            v-model.lazy="floorArea"
            :class="classes"
            aria-describedby="hasznos_terulet_m2"
            autocomplete="off"
          />
          <div class="input-group-append d-block dark-border">
            <span class="input-group-text" id="hasznos_terulet_m2">m2</span>
          </div>
        </div>
        <small
          id="foepulet_alapterulet-error"
          class="text-danger input-alert"
          >{{ errors[0] }}</small
        >
      </ValidationProvider>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" for="epulet_epites_ev"
        >Az ingatlan építési éve: <span class="text-danger">*</span>
        <button
          type="button"
          class="info"
          id="foepulet_epites_ev-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?
        </button></label
      >
      <ValidationProvider
        :rules="{
          required: true,
          min_value: 1900,
          max_value: new Date().getYear() + 1900,
        }"
        v-slot="{ errors, classes }"
        class="col-sm-8"
      >
        <input
          class="form-control dark-border"
          type="number"
          min="1900"
          :max="new Date().getYear() + 1900"
          id="epulet_epites_ev"
          name="epites_eve"
          :class="classes"
          v-model.lazy="builtYear"
        />
        <small id="epites_eve-error" class="text-danger input-alert">{{
          errors[0]
        }}</small>
      </ValidationProvider>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" for="ingatlan_lakok"
        >Hány lakó tartózkodik életvitelszerűen a biztosítani kívánt
        ingatlanban?
        <span class="text-danger">*</span>
        <button
          type="button"
          class="info"
          id="foepulet_lakok-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?
        </button></label
      >
      <ValidationProvider
        :rules="
          `required|min_value:${
            propertyInhabitated === 0 ? '0' : '1'
          }|max_value:50`
        "
        v-slot="{ errors, classes }"
        class="col-sm-8"
      >
        <div class="input-group">
          <input
            class="form-control"
            type="number"
            :min="0"
            :max="50"
            id="ingatlan_lakok"
            name="lakok_szama"
            v-model="residents"
            :class="{ classes, 'dark-border': true }"
            aria-describedby="ingatlan_lakok_fo"
            :readonly="propertyInhabitated === 0"
          />
          <div class="input-group-append d-block dark-border">
            <span class="input-group-text" id="ingatlan_lakok_fo">fő</span>
          </div>
        </div>
        <small id="lakok-error" class="text-danger input-alert">{{
          errors[0]
        }}</small>
      </ValidationProvider>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" for="foepulet_falazat"
        >Milyen a biztosítani kívánt főépület falazata?
        <span class="text-danger">*</span>
        <button
          type="button"
          class="info"
          id="foepulet_falazat-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?
        </button></label
      >
      <div class="col-sm-8">
        <select
          class="form-select dark-border"
          id="foepulet_falazat"
          name="foepulet_falazat"
          v-model="wallType"
          required
        >
          <option :value="'tegla'">Tégla</option>
          <option :value="'beton'">Beton</option>
          <option :value="'ko'">Kő</option>
          <option :value="'panel'">Panel</option>
          <option :value="'konnyuszerk'">Könnyűszerkezetes</option>
          <option :value="'fa'">Fa</option>
          <option :value="'valyog'">Vályog</option>
          <option :value="'vegyes'">Vegyes (vályog és szilárd)</option>
        </select>
        <span v-if="showPropertyWallWarning()"
          ><small class="text-warning fw-bold"
            >A megadott falazat típusra Édes Otthon Lakásbiztosítás nem
            köthető.</small
          ></span
        >
        <small
          id="foepulet_falazat-error"
          class="text-danger input-alert"
        ></small>
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" for="foepulet_tetozet"
        >Milyen a biztosítani kívánt főépület tetőzete?
        <span class="text-danger">*</span>
        <button
          type="button"
          class="info"
          id="foepulet_tetozet-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?
        </button></label
      >
      <div class="col-sm-8">
        <select
          class="form-select dark-border"
          id="foepulet_tetozet"
          name="foepulet_teto"
          v-model="roofType"
          required
        >
          <option :value="'cserep'">Cserép</option>
          <option :value="'pala'">Pala</option>
          <option :value="'nad'">Nád</option>
          <option :value="'fazsindely'">Fazsindely</option>
          <option :value="'szalma'">Szalma</option>
          <option :value="'bitumen'">Bitumenes</option>
          <option :value="'muanyag'">Műanyag</option>
          <option :value="'fem'">Fém</option>
          <option :value="'hullamlemez'">Bitumenes hullámlemez</option>
        </select>
        <span v-if="showPropertyRoofWarning()"
          ><small class="text-warning fw-bold"
            >A megadott tetőzet típusra Édes Otthon Lakásbiztosítás nem
            köthető.</small
          ></span
        >
        <small
          id="foepulet_tetozet-error"
          class="text-danger input-alert"
        ></small>
      </div>
    </div>
    <div class="form-group row mb-3" v-show="contractFor !== 3">
      <label class="col-sm-4" for="ujraepites_ingatlan"
        >Választott fedezettípus <span class="text-danger">*</span>
        <button
          type="button"
          class="info"
          id="ujraepites_ingatlan-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?
        </button></label
      >
      <div class="col-sm-8">
        <select
          class="form-select dark-border"
          id="ujraepites_ingatlan"
          name="ujraepites_ingatlan"
          v-model="rebuild_building"
          required
        >
          <option :value="0">Biztosítási összeg</option>
          <option :value="1">Újjáépítési érték</option>
        </select>
        <small id="ujraepites-error" class="text-danger input-alert"></small>
      </div>
    </div>
    <div v-if="contractFor !== 3 && rebuild_building === 0">
      <div class="form-group row mb-3">
        <label class="col-sm-4" for="ajanlott_bizt"
          >A Biztosító által ajánlott biztosítási összeg:
          <button
            type="button"
            class="info"
            id="ajanlott_bizt_foepulet-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <div class="col-sm-8">
          <input
            class="form-control dark-border"
            id="ajanlott_bizt"
            :value="recommendedInsurancePrice | currency"
            readonly
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4" for="valasztott_bizt"
          >Az Ön által választott biztosítási összeg:
          <button
            type="button"
            class="info"
            id="valasztott_bizt_foepulet-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <ValidationProvider
          :rules="{ required: true, currency_min: recommendedInsurancePrice }"
          v-slot="{ errors, classes }"
          class="col-sm-8"
        >
          <div class="input-group">
            <input
              v-currency="{ valueRange: { min: 0 } }"
              class="form-control dark-border"
              id="valasztott_bizt"
              name="ingatlan_erteke"
              :class="{ classes, 'dark-border': true }"
              aria-describedby="valasztott_ar_foepulet-prepend"
              v-model="chosenInsurancePrice"
              @click="clickedMainBuildingPrice = true"
              @focus="clickedMainBuildingPrice = true"
            />
            <div class="input-group-append d-block dark-border">
              <span class="input-group-text" id="valasztott_ar_foepulet-prepend"
                >Ft</span
              >
            </div>
          </div>
          <small
            id="valasztott_ar_foepulet-error"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
      </div>
    </div>
    <div>
      <div v-show="false" class="col-2">
        <button
          class="btn btn-red w-100 d-flex align-items-center justify-content-center"
          @click.prevent="getCovers"
        >
          Limitek igénylése
        </button>
      </div>
      <div v-show="false" class="col-2">
        <button
          class="btn btn-red w-100 d-flex align-items-center justify-content-center"
          @click.prevent="getPremium"
        >
          getPremium
        </button>
      </div>
      <h1 class="mt-5">
        Biztosítani Kívánt Melléképületek Adatai
        <button
          type="button"
          class="info"
          id="mellekepuletek-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?
        </button>
      </h1>
      <div class="form-group row mb-5">
        <label class="col-sm-4" for="mellekepuletek"
          >Biztosítani kívánt melléképületek száma:</label
        >
        <div class="col-sm-4 col-md-2 mb-4">
          <input
            class="form-control dark-border"
            type="number"
            readonly
            :value="sideBuildings.length"
            id="mellekepuletek"
          />
        </div>
        <div class="col-sm-4 col-md-2">
          <button
            type="button"
            class="add-new-item btn btn-outline-danger w-100"
            @click="addSideBuilding"
          >
            Hozzáadás
          </button>
        </div>
      </div>
      <div v-for="(building, key) in sideBuildings" :key="key">
        <h2 v-if="sideBuildings.length > 1" class="mt-5">
          {{ key + 1 }}. melléképület adatai
        </h2>
        <SideBuilding :building="building" :bKey="key" />
      </div>
      <div
        v-if="
          sideBuildings.length > 0 &&
            contractFor !== 3 &&
            rebuild_building === 0
        "
      >
        <hr class="mb-5" />
        <div class="form-group row mb-3">
          <label class="col-sm-4" :for="`mellek_ajanlott_bizt`"
            >A Biztosító által ajánlott biztosítási összeg:
            <button
              type="button"
              class="info"
              id="mellek_ajanlott_bizt-tooltip"
              data-toggle="tooltip"
              data-placement="right"
              title=""
            >
              ?
            </button></label
          >
          <div class="col-sm-8">
            <input
              class="form-control dark-border"
              :id="`mellek_ajanlott_bizt`"
              :value="sideBuildingsRecommendedPrice | currency"
              readonly
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4" :for="`valasztott_ar_mellekepulet`"
            >Az Ön által választott biztosítási összeg:
            <button
              type="button"
              class="info"
              id="valasztott_ar_mellekepulet-tooltip"
              data-toggle="tooltip"
              data-placement="right"
              title=""
            >
              ?
            </button></label
          >
          <ValidationProvider
            :rules="{
              required: true,
              currency_min: sideBuildingsRecommendedPrice,
              currency_max: 40000000,
            }"
            v-slot="{ errors, classes }"
            class="col-sm-8"
          >
            <div class="input-group">
              <input
                v-currency="{ valueRange: { min: 0, max: 40000000 } }"
                class="form-control"
                :id="`valasztott_ar_mellekepulet`"
                :name="`valasztott_ar_mellekepulet`"
                :aria-describedby="`valasztott_ar_mellekepulet-prepend`"
                v-model="sideBuildingsChosenPrice"
                :class="{ classes, 'dark-border': true }"
                required
                @click="clickedSideBuildingPrice = true"
                @focus="clickedSideBuildingPrice = true"
              />
              <div class="input-group-append d-block">
                <span
                  class="input-group-text"
                  :id="`valasztott_ar_mellekepulet-prepend`"
                  >Ft</span
                >
              </div>
            </div>
            <small
              id="valasztott_ar_mellekepulet-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
      </div>
    </div>
    <div v-if="contractFor !== 2">
      <h1 class="mt-5">Biztosítani Kívánt Ingóságok Adatai</h1>
      <h2>Általános Ingóságok</h2>
      <div class="form-group row mb-3">
        <label class="col-sm-4" for="ujraepites_ingosag"
          >Választott fedezettípus <span class="text-danger">*</span>
          <button
            type="button"
            class="info"
            id="ujraepites_ingosag-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <div class="col-sm-8">
          <select
            class="form-select dark-border"
            id="ujraepites_ingosag"
            name="ujraepites_ingosag"
            v-model="rebuild_ingosag"
            required
          >
            <option :value="0">Biztosítási összeg</option>
            <option :value="1">Újrabeszerzési érték</option>
          </select>
          <!-- <input
            class="form-check-input"
            type="radio"
            name="ujraepites"
            id="ujraepites_nem"
            :value="0"
            v-model="rebuild"
          />
          <label class="form-check-label" for="ujraepites_nem">
            Nem
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ujraepites"
            id="ujraepites_igen"
            :value="1"
            v-model="rebuild"
          />
          <label class="form-check-label" for="ujraepites_igen">
            Igen
          </label> -->

          <small id="ujraepites-error" class="text-danger input-alert"></small>
        </div>
      </div>
      <div class="form-group row mb-3" v-show="rebuild_ingosag === 0">
        <label class="col-sm-4" for="ajanlott_ingosag_bizt"
          >Ajánlott ingóság biztosítási összeg:
          <button
            type="button"
            class="info"
            id="ajanlott_ingosag_bizt_osszeg-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
          >
            ?
          </button></label
        >
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control dark-border"
            id="ajanlott_ingosag_bizt"
            readonly
            :value="calculatedInsurancePrice | currency"
          />
        </div>
      </div>
      <div
        class="form-group row mb-3"
        v-if="calculatedInsurancePrice && rebuild_ingosag === 0"
      >
        <label class="col-sm-4"
          >Elfogadja? <span class="text-danger">*</span></label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ajanlott_bizt_osszeg_elfogad"
              id="ajanlott_bizt_osszeg_elfogad_igen"
              :value="1"
              v-model="acceptCalculatedInsurance"
            />
            <label
              class="form-check-label"
              for="ajanlott_bizt_osszeg_elfogad_igen"
            >
              Elfogadom a felajánlott biztosítási összeget
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ajanlott_bizt_osszeg_elfogad"
              id="ajanlott_bizt_osszeg_elfogad_nem"
              :value="0"
              v-model="acceptCalculatedInsurance"
            />
            <label
              class="form-check-label"
              for="ajanlott_bizt_osszeg_elfogad_nem"
            >
              Más összeget adok meg
            </label>
          </div>
        </div>
      </div>
      <div
        class="form-group row mb-3"
        v-if="!acceptCalculatedInsurance && rebuild_ingosag === 0"
      >
        <label class="col-sm-4" for="ingosag_osszesen"
          >Ingóságok összesen: <span class="text-danger">*</span></label
        >
        <ValidationProvider
          :rules="{
            required: true,
            currency_min: calculatedInsuranceMin,
            currency_max: maxertekek.ingosag_max,
          }"
          v-slot="{ errors, classes }"
          class="col-sm-8"
        >
          <div class="input-group">
            <input
              v-currency="{ valueRange: { min: 0, max: 60000000 } }"
              class="form-control"
              id="ingosag_osszesen"
              name="ingosag_osszesen"
              aria-describedby="ingosag_osszesen-prepend"
              :class="{ classes, 'dark-border': true }"
              v-model="allGoodsPrice"
              @input="clickedAllGoodsPrice = true"
              @click="clickedAllGoodsPrice = true"
            />
            <div class="input-group-append d-block dark-border">
              <span class="input-group-text" id="ingosag_osszesen-prepend"
                >Ft</span
              >
            </div>
          </div>
          <small id="ingosag_osszesen-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
    </div>
    <ValidationProvider
      :rules="{ max_value: maxertekek.ingatlan_max }"
      :immediate="true"
      v-slot="{ errors }"
    >
      <input
        name="ingatlan_osszesen"
        id="ingatlan_osszesen"
        v-show="false"
        type="number"
        :value="buildingSum"
        aria-describedby="ingatlan-osszesen-error"
      />
      <small id="ingatlan-osszesen-error" class="text-danger input-alert">{{
        errors[0]
      }}</small>
    </ValidationProvider>
    <div v-if="process === 'EGYEDI'" class="text-danger">
      A választott tetőzet és/vagy falazat típusra nem tudunk automatikusan
      biztosítási díjat számolni. Ebben az esetben biztosítási ajánlatát egyedi
      elbírálás alapján állítjuk ki.
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import SideBuilding from "./components/SideBuilding";
import Select2 from "v-select2-component";
import Datepicker from "vuejs-datepicker";
import { hu } from "vuejs-datepicker/dist/locale";
import { ValidationProvider } from "vee-validate";
import { parse as parseMoney } from "vue-currency-input";
import moment from "moment";

export default {
  components: {
    SideBuilding,
    Select2,
    Datepicker,
  },
  data() {
    const now = new Date();
    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - 1,
    );
    const minDate = new Date();
    minDate.setFullYear(1900);
    minDate.setMonth(1);
    minDate.setDate(1);
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() - 18);
    maxDate.setMonth(now.getMonth());
    maxDate.setDate(now.getDate());
    const birthMinDate = moment(minDate).format("YYYY-MM-DD");
    const birthMaxDate = moment(maxDate).format("YYYY-MM-DD");
    const riskStartMinDate = moment(
      new Date(new Date().setDate(now.getDate() + 1)),
    ).format("YYYY-MM-DD");
    const riskStartMaxDate = moment(
      new Date(new Date().setDate(now.getDate() + 180)),
    ).format("YYYY-MM-DD");
    // const riskStartMinDate = new Date(new Date().setDate(now.getDate() + 1)).toISOString().split("T")[0];
    // const riskStartMaxDate = new Date(new Date().setDate(now.getDate() + 180)).toISOString().split("T")[0];
    return {
      hu: hu,
      cityNames: [],
      summaryPrice: 0,
      clickedMainBuildingPrice: false,
      clickedSideBuildingPrice: false,
      clickedAllGoodsPrice: false,
      bornInitialDate: maxDate,
      birthMinDate,
      birthMaxDate,
      riskStartMinDate,
      riskStartMaxDate,
      riskStartDisabledDates: {
        customPredictor: function(date) {
          const maxDate = new Date().setDate(now.getDate() + 180);
          return date < now || date > maxDate;
        },
      },
      bornDisabledDates: {
        customPredictor: function(date) {
          return date > maxDate || date < minDate;
        },
      },
      maxBornDate: maxDate,
      // fetch_uid() {
      //   const search_params = window.location.search.substring(1).split('&');
      //   search_params.forEach((param) => {
      //     const [key, value] = param.split('=');
      //     if (key == 'fetch_uid' && value) {
      //       return True;
      //     }
      //   });
      //   return False;
      // }
    };
  },
  mounted() {
    if (this.fetch_uid) setTimeout(() => this.validate(), 2000);
  },
  props: ["validate"],
  computed: {
    ...mapFields([
      "cities",
      "riskSettings.startDate",
      "generalInfo.contractType",
      "generalInfo.contractFor",
      "generalInfo.propertyType",
      "generalInfo.propertyInhabitated",
      "generalInfo.propertyOutskirts",
      "generalInfo.rebuild_building",
      "generalInfo.rebuild_ingosag",
      "generalInfo.propertyPhysicalJob",
      "generalInfo.propertyPhysicalJobName",
      "generalInfo.propertyOwnRight",
      "generalInfo.rbnb",
      "generalInfo.rbnbPrice",
      "generalInfo.propertyZip",
      "generalInfo.propertyName",
      "generalInfo.selectedPropertyName",
      // Main Building Insurance
      "insuranceProperty.floorArea",
      "insuranceProperty.recommendedInsurancePrice",
      "insuranceProperty.chosenInsurancePrice",
      "insuranceProperty.builtYear",
      "insuranceProperty.residents",
      "insuranceProperty.wallType",
      "insuranceProperty.roofType",
      // Personal Goods
      "insurancePersonalGoods.calculatedInsurancePrice",
      "insurancePersonalGoods.acceptCalculatedInsurance",
      "insurancePersonalGoods.allGoodsPrice",
      "MFOLoaded",
      "dm",
      "partnertipus",
      "insuredSettings.contractedIsInsured",
      "chosenAccessories",
      "process",
      "stopProcess",
      "maxertekek",
      "fetch_uid",
    ]),
    ...mapFields({
      sideBuildingsTemplate: "insuranceSideBuildings.template",
      sideBuildings: "insuranceSideBuildings.list",
      contractorBornDate: "contractSettings.bornDate",
      sideBuildingsRecommendedPrice:
        "insuranceSideBuildings.recommendedInsurancePrice",
      sideBuildingsChosenPrice: "insuranceSideBuildings.chosenInsurancePrice",
    }),
    ...mapGetters({
      data: "getAllState",
    }),
    propertyNameIsArray: function() {
      return (
        typeof this.propertyName === "object" &&
        this.propertyName &&
        this.propertyName.length > 0
      );
    },
    zipCodes: {
      get() {
        return Object.keys(this.cities);
      },
    },
    hasAllPremiumProperties() {
      if (
        this.contractorBornDate &&
        this.propertyZip &&
        this.propertyZip.toString().length === 4 &&
        this.floorArea &&
        this.floorArea >= 10 &&
        this.builtYear &&
        this.builtYear >= 1900 &&
        String(this.rebuild_building) &&
        String(this.rebuild_ingosag)
      ) {
        let premiumString = `${this.contractorBornDate}|${this.propertyZip}|${this.floorArea}|${this.builtYear}|${this.rebuild_building}|${this.rebuild_ingosag}|`;
        // ${this.propertyType}|${this.propertyInhabitated}|${this.propertyOutskirts}|${this.propertyOwnRight}|${this.wallType}
        this.sideBuildings.forEach(
          (sb) =>
            (premiumString += `${sb.floorArea};${sb.wallType};${sb.roofType}|`),
        );
        return premiumString;
      }
      return;
    },
    calculatedInsuranceMin: function() {
      if (this.propertyInhabitated === 0) {
        return 1000000;
      } else {
        return parseInt(this.calculatedInsurancePrice * 0.5);
      }
    },
    // formattedStartDate: {
    //     get() {
    //       if (!this.startDate) return;
    //       const date = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate()+1).toISOString().split("T")[0]
    //       // console.log("formatted startdate: " + date);
    //       return date;
    //     }
    // },
    // formattedBornDate: {
    //     get() {
    //       if (!this.contractorBornDate) return;
    //       const date = new Date(new Date(this.contractorBornDate).getFullYear(), new Date(this.contractorBornDate).getMonth(), new Date(this.contractorBornDate).getDate()+1).toISOString().split("T")[0]
    //       // console.log("formatted borndate: " + date);
    //       return date;
    //     },
    // },
    buildingSum: function() {
      let mainInsurance;
      let sideInsurance;

      try {
        mainInsurance = parseMoney(
          this.chosenInsurancePrice,
          window.currencyInputOptions,
        );
      } catch {
        mainInsurance = this.chosenInsurancePrice;
      }

      try {
        sideInsurance = parseMoney(
          this.sideBuildingsChosenPrice,
          window.currencyInputOptions,
        );
      } catch {
        sideInsurance = this.sideBuildingsChosenPrice;
      }

      return mainInsurance + sideInsurance;
    },
  },
  created() {
    this.$store.dispatch("updateMarks");
  },
  watch: {
    propertyType: function(type) {
      if (!this.MFOLoaded) return;

      if (type == "lakas") {
        this.wallType = "panel";
        this.roofType = "bitumen";
      } else {
        this.wallType = "tegla";
        this.roofType = "cserep";
      }
    },
    propertyZip: function() {
      const zipCodeList = Object.keys(this.cities);

      if (
        zipCodeList.length === 0 ||
        (zipCodeList.length > 0 && !zipCodeList.includes(this.propertyZip))
      )
        return (this.cityNames = []);

      this.selectedPropertyName = null;
      const zipData = this.cities[this.propertyZip];

      if (!zipData) return (this.cityNames = []);

      this.cityNames =
        typeof zipData.telepules === "string"
          ? [zipData.telepules]
          : Object.values(zipData.telepules);

      if (this.cityNames.length === 1) {
        this.selectedPropertyName = this.cityNames[0];
      }
    },
    chosenInsurancePrice: function(value) {
      if (!this.clickedMainBuildingPrice) return;

      this.$store.commit("setMainInsuranceChangedState", true);
    },
    sideBuildingsChosenPrice: function(value) {
      if (!this.clickedSideBuildingPrice) return;

      this.$store.commit("setSideInsuranceChangedState", true);
    },
    allGoodsPrice: function(value) {
      if (!this.clickedAllGoodsPrice) return;

      this.$store.commit("setAllGoodsPriceChangedState", true);
    },
    propertyPhysicalJob: function(job) {
      if (job === 0) {
        this.$store.commit("setGeneralPropertyValues", {
          name: "propertyPhysicalJobName",
          value: "",
        });
      }
    },
    hasAllPremiumProperties: function() {
      if (this.hasAllPremiumProperties) {
        // console.log("premium call")
        this.getPremium();
      }
    },
    rebuild_ingosag: function() {
      if (this.rebuild_ingosag === 0) {
        this.$store.commit("setInsurancePersonalGoods", {
          name: "acceptCalculatedInsurance",
          value: 1,
        });
      }
    },
    contractFor: function() {
      // reset chosenAccessories
      Object.keys(this.chosenAccessories).forEach((item) => {
        if (this.chosenAccessories[item].selected) {
          this.$store.commit("setAccessory", item);
          this.$store.commit("setDefaultAccessory", item);
        }
      });
    },
    propertyInhabitated: function() {
      Object.keys(this.chosenAccessories).forEach((item) => {
        if (this.chosenAccessories[item].selected) {
          this.$store.commit("setAccessory", item);
          this.$store.commit("setDefaultAccessory", item);
        }
      });

      if (this.propertyInhabitated === 0) {
        this.$store.commit("setInsurancePropertyValues", {
          name: "residents",
          value: 0,
        });
      } else if (this.residents === 0) {
        this.$store.commit("setInsurancePropertyValues", {
          name: "residents",
          value: 1,
        });
      }
    },
    propertyOwnRight: function() {
      if (this.propertyOwnRight !== "sajat_berbe") {
        this.$store.commit("setGeneralPropertyValues", {
          name: "rbnb",
          value: 0,
        });
      }
    },
  },
  methods: {
    showPropertyWallWarning() {
      return this.stopProcess.fo_fal?.includes(this.wallType);
    },
    showPropertyRoofWarning() {
      return this.stopProcess.fo_teto?.includes(this.roofType);
    },
    // showSideWallWarning(idx) {
    //   return this.stopProcess.mell_fal.includes(this.roofType);
    // },
    // showSideRoofWarning(idx) {
    //   return this.stopProcess.mell_teto.includes(this.roofType);
    // },
    addSideBuilding() {
      if (this.sideBuildings.length < 5)
        this.$store.commit(
          "addSideBuilding",
          Object.assign({}, this.sideBuildingsTemplate),
        );
    },
    showPropertyPhysicalWarning() {
      return this.propertyPhysicalJob === 1;
    },
    getCovers() {
      this.$store.dispatch("getcovers", 1);
    },
    getPremium() {
      this.$store.dispatch("getPremium", 1);
    },
    formatDate(dateToFormat) {
      const date = new Date(dateToFormat).toISOString().split("T")[0];
      // console.log("formatted date: " + date);
      return date;
    },
  },
};
</script>

<style lang="scss">
.select2-selection__rendered {
  line-height: 38px !important;
}
.select2-container .select2-selection--single {
  height: 38px !important;
  border-color: #ced4da;
}
.select2-selection__arrow {
  height: 38px !important;
}
</style>
